import { RequestStatus } from "../../../request";

export interface ROASState {
  report: ROASReport | null;
  fetchROASReportRequestState: RequestStatus;
}

export const initialState: ROASState = {
  report: null,
  fetchROASReportRequestState: {
    isLoading: false,
    isSuccessful: false,
    isFailed: false,
  },
};

export function ROAS(state = initialState, action: any) {
  switch (action.type) {
    case "roas-update-request-state":
      return {
        ...state,
        fetchROASReportRequestState: action.requestState,
      };

    case "roas-update-report":
      return {
        ...state,
        report: action.report,
      };

    case "reset-data":
      return initialState;

    case "roas-reset-data":
      return initialState;

    default:
      return state;
  }
}

export interface ROASRow {
  date: string;
  installs: number;
  spend: number;
  revenueD1: number;
  revenueD3: number;
  revenueD7: number;
  revenueD14: number;
  revenueD30: number;
  revenueD60: number;
  revenueD180: number;
  roasD0: number;
  roasD1: number;
  roasD3: number;
  roasD7: number;
  roasD14: number;
  roasD30: number;
  roasD60: number;
  roasD180: number;
}

export interface ROASReport {
  from: Date;
  until: Date;
  rows: ROASRow[];
}
